import { filledInputClasses, type Theme } from "@mui/material"
import { SearchTextFieldTheme } from "core/themes/src/definitions/components.types"

export const createSearchTextFieldTheme = (theme: Theme): SearchTextFieldTheme => ({
    styleOverrides: {
        root: {
            [`.${filledInputClasses.root}`]: {
                overflow: "visible",
                [`&.${filledInputClasses.focused}`]: {
                    boxShadow: "none !important",
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                },
                [`&.${filledInputClasses.error}`]: {
                    [`&.${filledInputClasses.focused}`]: {
                        boxShadow: "none !important",
                    },
                },
            },
        },
    },
    variants: [],
})
